import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styles from './SelectPlan.module.sass';

export const SelectPlan = () => {
  const { t } = useTranslation();
  const isLogged = useSelector((state) => state.get('header')).get('isLogged') || false;
  const user = useSelector((state) => state.get('header')?.get('userInfo')?.get('userType')) || 'free';

  if (isLogged || user !== 'free') return null;

  return (
    <div className={styles.SelectPlan}>
      <p>{t('route.selectPlan.choosePlanText')}</p>
      <a href="#planes">{t('route.selectPlan.choosePlanAction')}</a>
    </div>
  );
};
